import React from "react"
import CalculatorsInfoSectionWrapper from "./shared/calculatorsInfoSectionWrapper/CalculatorsInfoSectionWrapper"
import CalculatorsInfoSectionContent from "./shared/calculatorsInfoSectionContent/CalculatorsInfoSectionContent"
import CalculatorsInfoSectionDescription from "./shared/calculatorsInfoSectionDescription/CalculatorsInfoSectionDescription"
import CalculatorsInfo from "./shared/calculatorsInfo/CalculatorsInfo"

const CalculatorsInfoSection = () => {
  return (
    <CalculatorsInfoSectionWrapper>
      <CalculatorsInfoSectionContent>
        <CalculatorsInfoSectionDescription />
        <CalculatorsInfo />
      </CalculatorsInfoSectionContent>
    </CalculatorsInfoSectionWrapper>
  )
}

export default CalculatorsInfoSection
